module.exports = __webpack_public_path__ + "static/media/video-slash.de0e47e9.svg";